import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ClientsTableRow } from "./ClientsTableRow";
import type { Client } from "@/pages/Dashboard/Clients";

interface ClientsTableProps {
  clients: Client[];
  onEdit: (client: Client) => void;
}

export const ClientsTable = ({ clients, onEdit }: ClientsTableProps) => {
  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Phone</TableHead>
            <TableHead>Tags</TableHead>
            <TableHead>Services</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {clients.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} className="text-center text-muted-foreground">
                No clients found
              </TableCell>
            </TableRow>
          ) : (
            clients.map((client) => (
              <ClientsTableRow key={client.id} client={client} onEdit={onEdit} />
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};